import { render } from "./PlacesHistory.vue?vue&type=template&id=726b7730&scoped=true"
import script from "./PlacesHistory.vue?vue&type=script&lang=js"
export * from "./PlacesHistory.vue?vue&type=script&lang=js"

import "./PlacesHistory.vue?vue&type=style&index=0&id=726b7730&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-726b7730"]])

export default __exports__